( function () {
   
    'use strict';

    ( function ( $ ) {
        jQuery('.map-popup').magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            callbacks: {
              open: function() {
              jQuery("body").addClass("overflow");
             },
              close: function() {
              jQuery("body").removeClass("overflow");
              }
            }
          });
        
    } )( jQuery );
} )();

